import React, { useState, useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import { useToggle, useFetch } from 'hooks';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import LessonVersionModalContainer from './LessonVersionModalContainer';

const match = () =>
  matchPath(window.location.pathname, { path: '/lessons/:lessonId' });

const LessonVersionModal = () => {
  const lessonId = match()?.params?.lessonId;
  const [isOpen, toggleModal] = useToggle(false);
  const [lessonVersionState, setLessonVersionState] = useState({
    versions: [],
    page: 1,
    totalVersions: 0,
  });

  const { data, loading, error, initialLoading } = useFetch(
    `${routes.VERSIONS.INDEX(lessonId)}?page=${lessonVersionState.page}`,
  );
  const { data: lessonData, initialLoading: lessonDataInitialLoading } =
    useFetch(routes.LESSON(lessonId));

  useEffect(() => {
    if (!loading && !error) {
      setLessonVersionState(prevState => ({
        ...prevState,
        versions: [...prevState.versions, ...data?.versions?.data].sort(
          (a, b) => b.version - a.version,
        ),
        totalVersions: data?.versions?.totalVersions,
      }));
    }
  }, [data, error, loading, setLessonVersionState]);

  if (initialLoading || lessonDataInitialLoading)
    return (
      <div className="px-32">
        <Spinner />
      </div>
    );

  return (
    <div className="LessonVersionModal d-f">
      {lessonVersionState?.versions[0]?.version && (
        <>
          {`${t('versions.version_with_number', {
            version_number: lessonVersionState?.versions[0]?.version,
          })}`}{' '}
          <button className="u-linkBtn" type="button" onClick={toggleModal}>
            {t('versions.parentheses_wrapped_all_versions')}
          </button>
        </>
      )}
      {isOpen && (
        <LessonVersionModalContainer
          closeModal={toggleModal}
          setLessonVersionState={setLessonVersionState}
          isScormLesson={lessonData?.scorm}
          {...lessonVersionState}
        />
      )}
    </div>
  );
};

export default LessonVersionModal;
